import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(
		private httpService: HttpService
	) {}
	
	add(mnemonic: string,params?: any) {
		if (!params) params = {};
		this.httpService.post('log/'+mnemonic, params).subscribe((response:any)=>{},(err) => {});
	}
}
